import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { createActionCreator, createBoundActionCreator, createType } from '../../../../../shared/state/index.state';
import { MediaDevice } from '../../models/user-device.model';

/**
 * https://medium.com/frontend-fun/angular-ngrx-a-clean-and-clear-introduction-4ed61c89c1fc
 */

@Injectable()
export class UserDevicesActions {
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    //              ACTION CREATORS
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    static GET_USER_DEVICES = createActionCreator<number>(createType('[Admin:User:Devices] Get User Devices'));
    static GET_USER_DEVICES_SUCCESS = createActionCreator<Array<MediaDevice>>(createType('[Admin:User:Devices] Get User Devices Success'));
    static GET_USER_DEVICES_FAIL = createActionCreator<any>(createType('[Admin:User:Devices] Get User Devices Failed'));
    static SAVE_USER_DEVICES = createActionCreator<any>(createType('[Admin:User:Devices] Save User Devices'));
    static SAVE_USER_DEVICE_SUCCESS = createActionCreator<Array<MediaDevice>>(createType('[Admin:User:Devices] Save User Devices Success'));
    static SAVE_USER_DEVICE_FAIL = createActionCreator<any>(createType('[Admin:User:Devices] Save User Devices Failed'));

    static OPEN_SHARED_NUMBERS_DIALOG = createActionCreator(createType('[Admin:User:Devices] Open Shared Numbers Dialog'));

    static MAKE_USER_DEVICES_FORM_PRISTINE = createActionCreator<any>(createType('[Admin:User:Devices] Reset Dirty Form'));
    // Currently this is handled by tabs in angular1, as we check the condition even before firing route_change/navigation_change event
    // static ALERT_ROUTE_CHANGE_WITHOUT_SAVING = createActionCreator<any>(createType('[Admin:User:Devices] Alert Route Change Without Saving'));

    // When changes are made to shared number we need to remove the shared flag
    // TODO: Refactor when implement a lookup call to the backend after entering a phone number
    static UN_MARK_AS_SHARED_NUMBER = createActionCreator(createType('[Admin:User:Devices] Remove Marked as Shared Number'));

    constructor(private store: Store<any>) {}

    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    //              BOUND ACTIONS
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    getUserDevices = createBoundActionCreator(UserDevicesActions.GET_USER_DEVICES, this.store.dispatch.bind(this.store));
    saveUserDevices = createBoundActionCreator(UserDevicesActions.SAVE_USER_DEVICES, this.store.dispatch.bind(this.store));
    openSharedNumbersDialog = createBoundActionCreator(UserDevicesActions.OPEN_SHARED_NUMBERS_DIALOG, this.store.dispatch.bind(this.store));
    resetForm = createBoundActionCreator(UserDevicesActions.MAKE_USER_DEVICES_FORM_PRISTINE, this.store.dispatch.bind(this.store));
    unMarkAsSharedNumber = createBoundActionCreator(UserDevicesActions.UN_MARK_AS_SHARED_NUMBER, this.store.dispatch.bind(this.store));

    // alertRouteChangeWithoutSaving = createBoundActionCreator(UserDevicesActions.ALERT_ROUTE_CHANGE_WITHOUT_SAVING, this.store.dispatch.bind(this.store));
}
